import options from './add-user.component';

export default {
    selector: 'dtUacAddUser',
    options
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/users/add-user/index.js